import { render, staticRenderFns } from "./ProductTiles.vue?vue&type=template&id=15fc6f56&scoped=true&"
import script from "./ProductTiles.vue?vue&type=script&lang=js&"
export * from "./ProductTiles.vue?vue&type=script&lang=js&"
import style0 from "./ProductTiles.vue?vue&type=style&index=0&id=15fc6f56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fc6f56",
  null
  
)

export default component.exports